/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChangeOperation } from './ChangeOperation';
import {
    ChangeOperationFromJSON,
    ChangeOperationFromJSONTyped,
    ChangeOperationToJSON,
    ChangeOperationToJSONTyped,
} from './ChangeOperation';

/**
 * A Change Request Create Request is used to create a new Change Request.
 * It contains the necessary information to identify the Logistics Object and the requested changes.
 * 
 * @export
 * @interface ChangeRequestCreateRequest
 */
export interface ChangeRequestCreateRequest {
    /**
     * Revision of the Logistics Object that the Change Request is based on.
     * This is used to ensure that the changes are applied to the correct version of the Logistics Object.
     * 
     * @type {number}
     * @memberof ChangeRequestCreateRequest
     */
    logisticsObjectRevision: number;
    /**
     * Identifier of the member that created the Change Request.
     * This is used to track who requested the changes.
     * 
     * @type {string}
     * @memberof ChangeRequestCreateRequest
     */
    requestorMemberIdentifier?: string;
    /**
     * A description of the Change Request.
     * This should provide context for the requested changes and any relevant information.
     * 
     * @type {string}
     * @memberof ChangeRequestCreateRequest
     */
    description?: string;
    /**
     * 
     * @type {Array<ChangeOperation>}
     * @memberof ChangeRequestCreateRequest
     */
    operations: Array<ChangeOperation>;
}

/**
 * Check if a given object implements the ChangeRequestCreateRequest interface.
 */
export function instanceOfChangeRequestCreateRequest(value: object): value is ChangeRequestCreateRequest {
    if (!('logisticsObjectRevision' in value) || value['logisticsObjectRevision'] === undefined) return false;
    if (!('operations' in value) || value['operations'] === undefined) return false;
    return true;
}

export function ChangeRequestCreateRequestFromJSON(json: any): ChangeRequestCreateRequest {
    return ChangeRequestCreateRequestFromJSONTyped(json, false);
}

export function ChangeRequestCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeRequestCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'logisticsObjectRevision': json['logisticsObjectRevision'],
        'requestorMemberIdentifier': json['requestorMemberIdentifier'] == null ? undefined : json['requestorMemberIdentifier'],
        'description': json['description'] == null ? undefined : json['description'],
        'operations': ((json['operations'] as Array<any>).map(ChangeOperationFromJSON)),
    };
}

export function ChangeRequestCreateRequestToJSON(json: any): ChangeRequestCreateRequest {
    return ChangeRequestCreateRequestToJSONTyped(json, false);
}

export function ChangeRequestCreateRequestToJSONTyped(value?: ChangeRequestCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'logisticsObjectRevision': value['logisticsObjectRevision'],
        'requestorMemberIdentifier': value['requestorMemberIdentifier'],
        'description': value['description'],
        'operations': ((value['operations'] as Array<any>).map(ChangeOperationToJSON)),
    };
}

